import { watch } from 'vue';
import formatISO9075 from 'date-fns/formatISO9075';
import { Notify } from 'quasar';
import { callSync } from 'src/api';
import { commitSync } from './commitSync';
import {
  accessToken,
  eventosMat,
  eventosToSync,
  visible,
  loggedIn,
  motoristasMat,
  setAccessToken,
  veiculosMat,
  motivosMat,
  clientesMat,
  connected,
  tiposDeDespesaMat,
  fopsMat,
  foasMat,
  fornecedoresMat,
  despesasToSync,
  despesasMat,
  atendimentosMat,
  fornecedoresToSync,
  atendimentosToSync,
  synchronizing,
} from './state';
// import { log } from 'src/log';
import { callRefreshLogin } from 'src/api/callRefreshLogin';
import { reading } from 'src/localforage';

export { synchronizing };

const fmt = (val: Date | null): null | string =>
  val ? formatISO9075(val) : null;

/**
 * @returns {number} 2 refresh com senha, 1 refresh automático, 0 refresh não necessário
 */
export function needRefreshLogin(): 3 | 2 | 1 | 0 {
  const time = Math.floor(Date.now() / 1000);
  const exp = loggedIn.value?.exp ?? 0;
  if (time >= exp + 60 * 60 * 30) return 2;
  if (time >= exp) return 1;
  if (loggedIn.value?.rules === undefined) return 1;
  if (!loggedIn.value?.eid) return 1;
  return 0;
}

type SyncStrategy = 'hard' | 'soft';

export const doSync = async (strategy: SyncStrategy = 'soft') => {
  if (reading.value > 0) {
    // console.log('[doSync] aborted localforage not readed');
    return undefined;
  }
  if (!accessToken.value) {
    // console.log('[doSync] aborted accessToken is undefined');
    return undefined;
  }
  if (synchronizing.value) {
    // console.log('[doSync] aborted sync duplication');
    return undefined;
  }

  const refreshLogin = needRefreshLogin();

  if (refreshLogin === 1) {
    // console.log('[doSync] will auto refreshLogin');
    const stopWatch = watch(accessToken, function () {
      stopWatch();
      void doSync();
    });
    try {
      const data = await callRefreshLogin({});
      await setAccessToken(data.accessToken);
    } catch (err) {
      console.error(err);
      // log({
      //   category: 'exception',
      //   action: 'doSync',
      //   value: (err as Error).message,
      // });
      Notify.create({ type: 'negative', message: (err as Error).message });
    } finally {
      stopWatch();
    }
    return undefined;
  } else if (refreshLogin === 2) {
    // console.log('[doSync] need password to refreshLogin');
    location.href = '/#/refresh-login';
    return undefined;
  }

  synchronizing.value = true;
  try {
    // console.log('[doSync] callSync', strategy);
    const data = await callSync({
      atendimentos_mat: strategy === 'hard' ? null : fmt(atendimentosMat.value),
      despesas_mat: strategy === 'hard' ? null : fmt(despesasMat.value),
      motoristas_mat: strategy === 'hard' ? null : fmt(motoristasMat.value),
      veiculos_mat: strategy === 'hard' ? null : fmt(veiculosMat.value),
      eventos_mat: strategy === 'hard' ? null : fmt(eventosMat.value),
      motivos_mat: strategy === 'hard' ? null : fmt(motivosMat.value),
      clientes_mat: strategy === 'hard' ? null : fmt(clientesMat.value),
      fops_mat: strategy === 'hard' ? null : fmt(fopsMat.value),
      foas_mat: strategy === 'hard' ? null : fmt(foasMat.value),
      fornecedores_mat: strategy === 'hard' ? null : fmt(fornecedoresMat.value),
      tipos_de_despesa_mat:
        strategy === 'hard' ? null : fmt(tiposDeDespesaMat.value),
      eventos: eventosToSync.value,
      despesas: despesasToSync.value,
      fornecedores: fornecedoresToSync.value,
      atendimentos: atendimentosToSync.value,
    });
    // console.log('[doSync] commitSync');
    await commitSync(data);
  } catch (err) {
    console.error(err);
    // log({
    //   category: 'exception',
    //   action: 'doSync',
    //   value: (err as Error).message,
    // });

    if (!['Load failed', 'Failed to fetch'].includes((err as Error).message)) {
      Notify.create({ type: 'negative', message: (err as Error).message });
    }
  } finally {
    synchronizing.value = false;
  }
  // console.log('[doSync] end');
};

// const stopWatchReading = watch(reading, (r) => {
//   if (r === 0) {
//     if (accessToken.value === undefined) void setAccessToken(null);
//     else void doSync('hard');
//     stopWatchReading();
//   }
// });

let intervalId: undefined | NodeJS.Timeout = undefined;

watch(reading, (n) => n === 0 && doSync());

watch(
  () => (visible.value ? 1 : connected.value ? 2 : 0),
  (val) => {
    if (val > 0) {
      void doSync();
      if (intervalId === undefined) {
        // console.log('[syncInterval] start');
        intervalId = setInterval(function () {
          void doSync();
        }, 60 * 1000);
      }
    } else if (intervalId !== undefined) {
      // console.log('[syncInterval] stop');
      clearInterval(intervalId);
      intervalId = undefined;
    }
  },
  { immediate: true }
);
